"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _lodash = require("lodash");
var _controls = require("libs/utils/controls");
var metaUtils = _interopRequireWildcard(require("shared/libs/utils/metadata"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var GENERATED_DEFAULT_VALUE_PLACEHOLDER = '{{bstg:random}}';
var vanillaMetadata = window.BSTG.services.metadata;
var MetadataService = /* @ngInject */function MetadataService($q, $filter, eventService, bulkUpdateService) {
  var __METADATA_CACHE = {};

  // # # # #
  // public
  // # # # #

  var metadataService = {
    FIELD_CATEGORY_CATCHALL: 'base data',
    FIELD_CATEGORY_GENERAL: 'general',
    getFieldPlacement: _controls.getFieldPlacement,
    compileMetadata: vanillaMetadata.compileMetadata.bind(vanillaMetadata),
    fetchAllMetadata: function fetchAllMetadata(eventOrEventId) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var eventId, metadata;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (typeof eventOrEventId === 'string') {
                eventId = eventOrEventId;
              }
              if ((0, _lodash.isObject)(eventOrEventId)) {
                eventId = eventOrEventId._id || eventOrEventId.id;
              }
              _context.next = 4;
              return vanillaMetadata.getMetadata(eventId, 0);
            case 4:
              metadata = _context.sent;
              __METADATA_CACHE[eventId] = metadata;
              return _context.abrupt("return", metadata);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    fetchOverrideMetadataBit: function fetchOverrideMetadataBit(event) {
      var fpType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
      var _id = "".concat(metaUtils.OVERRIDE_METADATA_BIT_ID_PREFIX).concat(fpType);
      return eventService.getEventDocById(event, _id).then(function (data) {
        return data.data;
      }).catch(function (err) {
        if (err.status === 404) {
          return {};
        }
        throw err;
      });
    },
    getOverrideBitFromDiff: metaUtils.getOverrideBitFromDiff,
    updateOverrideMetadataBit: function updateOverrideMetadataBit(eventId, eventNode, metadataDictOrList) {
      var fpType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'default';
      var _id = "".concat(metaUtils.OVERRIDE_METADATA_BIT_ID_PREFIX).concat(fpType);
      var baseMetadataDict = {
        _id: _id,
        fp_ext_id: _id,
        fp_bit_priority: metaUtils.OVERRIDE_METADATA_BIT_PRIORITY,
        fp_owner: metaUtils.OVERRIDE_METADATA_BIT_OWNER
      };
      var metadataDict = !_.isArray(metadataDictOrList) ? _.extend(_.clone(metadataDictOrList), baseMetadataDict) : metadataDictOrList.reduce(function (dict, item) {
        if (!dict[fpType]) {
          dict[fpType] = {};
        }
        dict[fpType][item.field] = _.omit(item, 'field');
        return dict;
      }, baseMetadataDict);

      // save the updated metadata doc, keeping its existing db id
      return bulkUpdateService.createDocs(eventId, eventNode, metaUtils.OVERRIDE_METADATA_BIT_TYPE, metadataDict, {
        keepId: true
      }).then(function () {
        return metadataService.fetchAllMetadata(eventId, {
          eventNode: eventNode,
          forceUpdate: true
        });
      });
    },
    saveMetadataFieldsToOverride: function saveMetadataFieldsToOverride(eventId, eventNode, fpType, metadataFieldList, reprTemplates, currentMetadata) {
      var event = {
        id: eventId,
        _id: eventId,
        node: eventNode
      };
      return $q.all([metadataService.fetchAllMetadata(eventId, {
        eventNode: event.node,
        forceUpdate: true
      }), metadataService.fetchOverrideMetadataBit(event, fpType)]).then(function (results) {
        var _results = _slicedToArray(results, 2),
          allMetadata = _results[0],
          overrideBit = _results[1];
        // For now this check ensures that metadata editor won't allow conflict.
        // No change for the excel data import to this day as it's not a big source of conflict
        if (currentMetadata && currentMetadata._rev !== allMetadata._rev) {
          alert('Metadata have been updated while you were working on them. Please take note of your changes and refresh the page');
          throw new Error('Outdated metadata');
        }
        var finalOverrideBit = metadataService.getOverrideBitFromDiff(eventId, fpType, metadataFieldList, allMetadata, overrideBit, reprTemplates);

        // refresh the local metadata cache
        return metadataService.updateOverrideMetadataBit(eventId, event.node, finalOverrideBit, fpType).then(function () {
          return metadataService.fetchAllMetadata(eventId, {
            eventNode: event.node,
            forceUpdate: true
          });
        });
      });
    },
    getCachedMetadata: function getCachedMetadata(eventId) {
      return __METADATA_CACHE[eventId];
    },
    getCachedMetadataForType: function getCachedMetadataForType(eventId, fpType) {
      var mergeDynamicExtensions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var filterPrivate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var filterPrivateExceptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
      var metadata = this.getCachedMetadata(eventId);
      return metaUtils.buildMetadataForType(metadata, fpType, mergeDynamicExtensions, filterPrivate, filterPrivateExceptions);
    },
    getCachedMetadataForTypeAsArray: function getCachedMetadataForTypeAsArray(eventId, fpType) {
      var mergeDynamicExtensions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var mdHash = this.getCachedMetadataForType(eventId, fpType, mergeDynamicExtensions);
      return metaUtils.convertMetadataHashToOrderedList(mdHash);
    },
    getCachedReprTemplateForType: function getCachedReprTemplateForType(eventId, fpType, mergeDynamicExtensions) {
      var mdHash = metadataService.getCachedMetadataForType(eventId, fpType, mergeDynamicExtensions);
      return mdHash._representation;
    },
    getCachedBulkEditFlagForType: vanillaMetadata.isFpTypeBulkEditable.bind(vanillaMetadata),
    getCachedDuplicateFlagForType: vanillaMetadata.isFpTypeDuplicable.bind(vanillaMetadata),
    /**
     * This method will safely interpolate mustache values using an i18n filter.
     *
     * @param {String} label the label that can contain mustache markup.
     * @param {Object} context the object that contains mustache interpolation values.
     */
    translateObjects: function translateObjects(label, context, skipEscape) {
      var matches = (label || '').match(/{{([^}{}]*)}}/g);
      if (!matches) {
        return label;
      }

      // Search for relevand mustache keys
      var fields = matches.map(function (k) {
        return k.replace('{{', '').replace('}}', '');
      });
      if (skipEscape) {
        label = label.replace(/{{/g, '{{{').replace(/}}/g, '}}}')
        // {{{ are turned into {{{{ > fix this
        // this could be done above with a pretty unreadable regexp
        .replace(/{{{{/g, '{{{').replace(/}}}}/g, '}}}');
      }

      // We don't want to modify the original content/model for labels, thus
      // we create a clone and operate on this.
      var ctx = (0, _lodash.clone)(context);
      var _iterator = _createForOfIteratorHelper(fields),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var key = _step.value;
          // if the desired mustache key is an object, it means that it's a
          // key that we must translate, thus we give it to the i18n filter.
          if ((0, _lodash.isObject)(context[key])) {
            ctx[key] = $filter('i18nFieldValueToString')(ctx[key]);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return window.BSTG.utils.dom.compile(label, ctx);
    },
    getReprLabelForItem: function getReprLabelForItem(eventId, doc, skipEscape) {
      var fpType = (0, _lodash.get)(doc, 'fp_type');
      if (!fpType) {
        return null;
      }
      var tmpl = metadataService.getCachedReprTemplateForType(eventId, fpType);
      if (!tmpl) {
        return null;
      }
      return this.translateObjects(tmpl, doc, skipEscape);
    },
    getReprLabelForItemOrUseTitle: function getReprLabelForItemOrUseTitle(eventId, doc) {
      var label = metadataService.getReprLabelForItem(eventId, doc);
      return label || doc.name || doc.title || doc.subject || doc.fp_ext_id || doc._id;
    },
    getCategoryGroupedMetadataFields: function getCategoryGroupedMetadataFields() {
      var metadataFieldsList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var event = eventService.getCurrentEvent();
      var ORDER_BOTTOM = 'x';
      var CATEGORY_OTHER = metadataService.FIELD_CATEGORY_CATCHALL;
      if (!_.isArray(metadataFieldsList) && _.isObject(metadataFieldsList)) {
        // fields object to list form
        metadataFieldsList = metaUtils.convertMetadataHashToOrderedList(metadataFieldsList);
      }
      var categoryOrderMap = {}; // to keep track of the lowest order per category!

      return _.chain(metadataFieldsList).compact().sortBy('order').map(function (field, idx) {
        // make sure all fields have orders
        if (_.isNaN(parseFloat(field.order))) {
          field.order = idx;
        }
        var _order = categoryOrderMap[field.category];
        // lowest order presides (and becomes the category order)

        if (!_.isNumber(_order) || field.order < _order) {
          categoryOrderMap[field.category] = field.order;
        }
        var isNotEditable = field._editable === false;
        var hasCustomController = field.kind === 'custom' && field.kind_options && field.kind_options.controller;
        var isPrivateField = field.field.startsWith('fp_');
        field.readOnly = Boolean(isNotEditable || hasCustomController || isPrivateField);
        if (field.context) {
          var eventContext = event.is_template ? 'template' : 'workspace';
          if (!field.context.includes(eventContext)) {
            field.hidden = true;
          }
        }
        return field;
      }).groupBy(function (field) {
        var category = field.category || CATEGORY_OTHER;
        var _order = categoryOrderMap[category];
        var order = _.isNumber(_order) ? _order : ORDER_BOTTOM;
        return "".concat(order, ":").concat(category);
      }).pairs().sortBy(function (pair) {
        return pair[0];
      })
      // back to category names
      .map(function (pair) {
        return {
          category: pair[0].split(':')[1],
          fields: pair[1],
          hasRequiredFields: pair[1].some(function (field) {
            var _field$validations;
            return (_field$validations = field.validations) === null || _field$validations === void 0 ? void 0 : _field$validations.required;
          })
        };
      }).sortBy(function (category) {
        return category.fields[0].order;
      }).map(function (obj, idx, list) {
        obj.previous = list[idx - 1];
        obj.next = list[idx + 1];
        return obj;
      }).value();
    },
    convertMetadataHashToOrderedList: metaUtils.convertMetadataHashToOrderedList,
    displaceInAppFieldsAsFieldKeys: function displaceInAppFieldsAsFieldKeys(mdHashOrArray) {
      var useInAppFieldKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var isArray = _.isArray(mdHashOrArray);
      var outHash = _.reduce(mdHashOrArray, function (outHash, fieldDescriptor, fieldKey) {
        if (!fieldDescriptor) {
          // ignore null fields
          return outHash;
        }
        var origKey = isArray ? fieldDescriptor.field : fieldKey;
        var newKey;
        if (!useInAppFieldKeys) {
          newKey = origKey;
        } else {
          newKey =
          // if in_app is a string use it, if it is only true infer the name
          _.isString(fieldDescriptor.in_app) ? fieldDescriptor.in_app : origKey;
        }
        outHash[newKey] = fieldDescriptor;
        if (isArray) {
          outHash[newKey].field = newKey;
        }
        return outHash;
      }, {});
      if (isArray) {
        return _.sortBy(_.values(outHash), 'order');
      } else {
        return outHash;
      }
    },
    // n.b. arrays only plz
    findFieldsWithFlag: metaUtils.findFieldsWithFlag,
    // recursively replace placeholders in val, and return the modified object
    // for now only {{bstg:random}} is supported
    replacePlaceholdersInTree: function replacePlaceholdersInTree(val) {
      if (!val) {
        return val;
      }
      if (_.isString(val) && val.match(GENERATED_DEFAULT_VALUE_PLACEHOLDER)) {
        return val.replace(new RegExp(GENERATED_DEFAULT_VALUE_PLACEHOLDER, 'g'), bulkUpdateService.generateAutoGeneratedValueString());
      }

      // handle array and object recursively
      if (_.isObject(val)) {
        _.each(val, function (value, key) {
          return val[key] = metadataService.replacePlaceholdersInTree(value);
        });
      }
      return val;
    },
    /**
     * Returns a document of type fp_type where all values are the default values.
     *
     * @param {Object} fields
     * @return {Object}
     */
    extractDefaults: function extractDefaults(fields) {
      return _.chain(fields).pairs()
      // retrieve default value for fields
      .map(function (regEntry) {
        var entry = regEntry[1];
        if (!entry) {
          return;
        }
        var field = entry.field || regEntry[0];

        // simple case, use field.default if not nested object
        if (entry.kind !== 'nested-object' || !_.isEmpty(entry.default) || !entry.kind_options || !entry.kind_options.fields) {
          // return a copy of the default value, so it can be modified
          return [field, _.clone(entry.default)];
        }

        // otherwise, extract default from kind_options fields
        var optionsFields = (entry.kind_options || {}).fields;
        if (optionsFields) {
          return [field, metadataService.extractDefaults(optionsFields)];
        }
      })
      // remove fields without defaults and undefined defaults
      .compact().filter(function (regEntry) {
        return !_.isUndefined(regEntry[1]);
      })
      // replace {{placeholders}} in default value
      .map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          field = _ref2[0],
          defaultValue = _ref2[1];
        return [field, metadataService.replacePlaceholdersInTree(defaultValue)];
      })
      // build final default object
      .object().value();
    },
    filterDuplicateTargetsExceptionsFields: metaUtils.filterDuplicateTargetsExceptionsFields,
    filterNullKindOptionsValues: function filterNullKindOptionsValues() {
      var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _.chain(values).pairs().filter(function (pair) {
        return pair[1] !== null;
      }).object().value();
    },
    getKindOptions: function getKindOptions() {
      return window.BSTG.services.metadata.ALL_KINDS;
    },
    /**
     * Extract values from a kind_otions and return a sorted select-ready structure
     * @param {Object} kindOptions a metadata kind_options structure
     * @return {Array}
     */
    getChoiceOptionsOrderedList: function getChoiceOptionsOrderedList() {
      var kindOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var kindValues = kindOptions.values || {};
      var kindValuesOrder = kindOptions.values_order || {};
      var filteredValues = metadataService.filterNullKindOptionsValues(kindValues);
      var maxOrder = 0;
      return _.chain(filteredValues).keys()
      // first assign known orders
      .map(function (key) {
        var order = kindValuesOrder[key];
        var option = {
          label: filteredValues[key],
          value: key
        };
        if (order || order === 0) {
          option.order = order;
          maxOrder = Math.max(maxOrder, order + 1);
        }
        return option;
      })
      // then only add missing order based on index
      .map(function (option, index) {
        if (option.order === undefined) {
          option.order = maxOrder + index;
        }
        return option;
      }).sortBy('order').value();
    },
    getTypeRepresentations: function getTypeRepresentations(metadataTypes, metadata) {
      var humanizeFn = $filter('humanize');
      var uppercaseFn = $filter('uppercaseFirstCharOfAllWords');
      return metadataTypes.map(function (key) {
        var rep = (metadata[key] || {})._type_representation;
        if (!_.isString(rep)) {
          rep = uppercaseFn(humanizeFn(key));
        }
        return {
          id: key,
          text: rep
        };
      })
      // only show types with a text
      .filter(function (_ref3) {
        var text = _ref3.text;
        return text;
      });
    }
  };
  return metadataService;
};
MetadataService.$inject = ["$q", "$filter", "eventService", "bulkUpdateService"];
MetadataService.$inject = ["$q", "$filter", "eventService", "bulkUpdateService"];
angular.module('backstage.services').factory('metadataService', MetadataService);